import { useState } from 'react'
import clsx from 'clsx'
import { RiPlayCircleFill } from '@remixicon/react'
import { useMediaLightbox } from 'src/context'
import { MediaLightboxProvider, MediaLightboxType } from 'src/components'
import { useVideoEmbed } from 'src/hook/useVideoEmbed'
import { Wrapper } from '../feedCardVideo/feedCardVideo.styles'
import { FeedCardExternalVideoProps } from './feedCardExternalVideo.types'

const FeedCardExternalVideo = ({ post, className }: FeedCardExternalVideoProps) => {
  const [hasLoadingError, setHasLoadingError] = useState(false)
  const { onOpenLightbox } = useMediaLightbox()
  const { youTube } = useVideoEmbed()

  const videoId = youTube.extractVideoId(post?.description) as string
  const src = youTube.getThumbnail({ videoId, resolution: 'hd' })

  const handleOpenLightbox = () => {
    onOpenLightbox({
      type: MediaLightboxType.IFRAME,
      provider: MediaLightboxProvider.YOUTUBE,
      src: videoId
    })
  }

  const handleError = () => {
    setHasLoadingError(true)
  }

  if (hasLoadingError) {
    return null
  }

  return (
    <Wrapper className={clsx(className, '_cursor-pointer')} onClick={handleOpenLightbox}>
      <RiPlayCircleFill
        size={68}
        className="_cursor-pointer _position-absolute play-icon"
        onClick={handleOpenLightbox}
      />

      <img
        src={src}
        alt={post.title}
        loading="lazy"
        className="_w-full _position-absolute"
        onError={handleError}
      />
    </Wrapper>
  )
}

export default FeedCardExternalVideo
